import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useNavigate } from 'react-router-dom';


function Registro() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(false);
  //const code = searchParams.get('code');
  const [code, setCode] = useState('');
  const [cardNumber, setcardNumber] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [amount, setAmount] = useState('');
  const [showBtnSearch, setShowBtnSearch] = useState(false);
  const [backAccountID, setBackAccountID] = useState('');

  const [bracelet, setBracelet] = useState('');
  const [invType, setInvType] = useState('');
  // Recover querystring 'b' only once on mount
  useEffect(() => {
    setBracelet(searchParams.get('b') || '');
    setInvType(searchParams.get('t') || '');
  }, []);

  const getDay = (input) => {
    const date = new Date(input);
    const day = date.getDate();

    return `${day}`;
  };

  const getMonth = (input) => {
    const date = new Date(input);
    const month = date.getMonth() + 1;

    return `${month}`;
  };

  const getYear = (input) => {
    const date = new Date(input);
    const year = date.getFullYear();

    return `${year}`;
  };
  console.log("idUsuario");
  //console.log(vid);
  const handleClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Lógica a ejecutar cuando se hace clic en el botón
    console.log("Botón clickeado");
    if (cardNumber.length > 0) {
      console.log(cardNumber);
      dataApi.getToken().then((response) => {
        console.log(response);
        if (response) {
          dataApi.getKidWithoutCard(response.token, cardNumber).then((responseVisitorId) => {
            if (responseVisitorId.isSuccess) {
              setAmount(responseVisitorId.amount);
              setBackAccountID(responseVisitorId.backAccountID);
              setCode(responseVisitorId.VisitorID);
              console.log(responseVisitorId);
              // if(responseVisitorId.VisitorID == code){
              dataApi.getKidByVisitorId(response.token, responseVisitorId.VisitorID).then((responseData) => {
                console.log(responseData);
                if (responseData.isSuccess) {
                  setShowBtnSearch(true)
                  setName(responseData.name);
                  setLastName(responseData.lastName);
                  setDay(getDay(responseData.birthdate));
                  setMonth(getMonth(responseData.birthdate));
                  setYear(getYear(responseData.birthdate));


                } else {
                  toast.error('Se encontro un error al buscar los datos del usuario');
                  cleanVar()
                }
              })
              /*}else{
              toast.error('El número de usuario no coincide con el usuario registrado en la tarjeta');
              }*/
            } else {
              toast.error('El número de tarjeta no tiene coincidencias con algún usuario');
              cleanVar()
            }

          });
        } else {
          toast.error('Se encontro un error al autenticarse');
          cleanVar()
        }
        console.log(response)


      }).catch();

    } else {
      toast.error('Ingrese el número de tarjeta');
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 5500);
  };

  const handleClickResumen = (e) => {
    // Lógica a ejecutar cuando se hace clic en el botón
    e.preventDefault();
    setIsLoading(true);

    if (parseFloat(amount) < 20) {
      toast.error('El monto debe ser mayor o igual a 20');
      setIsLoading(false);
      return;
    }

    //navigate(`/meta?code=${code}&amount=${amount}&backAccountID=${backAccountID}&t=c`);
    navigate(`/meta?code=${code}&amount=${amount}&backAccountID=${backAccountID}&t=${invType}&b=${encodeURIComponent(bracelet)}`);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const handleClickInicio = (e) => {
    // Lógica a ejecutar cuando se hace clic en el botón
    e.preventDefault();
    setIsLoading(true);
    navigate('/');
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const cleanVar = () => {
    setName('');
    setLastName('');
    setDay('');
    setMonth('');
    setYear('');
    setCode('');
    setShowBtnSearch(false)
  };

  return (
    <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
      <div className="cetes-background-inner">
        <div className="cetes-junior-header">
          <div className="info-header-cetes-junior">
            <div className="text-header-cetes">
              <h4 className="text-header-mayus">{t('registro_mainTitle')}</h4>
              <h4>{t('registro_subtitle')}</h4>
            </div>
          </div>
          <div className="logo_CETES_junior">
            <div className="logo logo-cetes">
              <img src={LogoCam} alt="Logo organización KidZania" />
            </div>
          </div>
        </div>
        <div className="registro-content">
          <div className="registro-form-cetes">
            <div className="registro-form-cetes-inner">
              <div className="form-row-cetes">
                <div className="input-txt-cetesJunior">
                  <div className="text-descriptivo">
                    <label htmlFor="card">{t('registro_cardNumber')}</label>
                  </div>
                  <input style={{ fontSize: '30px' }} type="text" name="card" onChange={e => setcardNumber(e.target.value)} id="card-number" required />
                </div>
                <div className="btn-cetesJunior">
                  <button type="submit" onClick={handleClick}>{t('registro_search')} </button>
                </div>
              </div>
              <div className="form-row-cetes">
                <div className="input-txt-cetesJunior">
                  <div className="text-descriptivo">
                    <label htmlFor="name">{t('registro_name')}</label>
                  </div>
                  <input style={{ fontSize: '30px' }} type="text" value={name} name="name" id="name-user" onChange={(e) => setName(e.target.value)} required />
                </div>
              </div>
              <div className="wrapper-container-inputs-date-lastname">
                <div className="form-row-cetes input-lastname">
                  <div className="input-txt-cetesJunior">
                    <div className="text-descriptivo">
                      <label htmlFor="last-name">{t('registro_lastName')}</label>
                    </div>
                    <input style={{ fontSize: '30px' }} type="text" value={lastName} name="last-name" id="last-name-user" onChange={(e) => setLastName(e.target.value)} required />
                  </div>
                </div>
                <div className="form-row-cetes input-number">
                  <div className="number-input-cetesJunior">
                    <div className="text-descriptivo">
                      <label htmlFor="birthdate">{t('registro_birthday')}</label>
                    </div>
                    <div className="wrapper-container">
                      <input style={{ fontSize: '30px' }} type="number" min="1" max="31" placeholder="dd" name="day" id="birthday" value={day} onChange={(e) => setDay(e.target.value)} required />
                      <input style={{ fontSize: '30px' }} type="number" min="1" max="12" placeholder="mm" name="month" id="birthday-month" value={month} onChange={(e) => setMonth(e.target.value)} required />
                      <input style={{ fontSize: '30px' }} type="number" min="1900" max="2099" placeholder="aa" name="year" id="birthday-year" value={year} onChange={(e) => setYear(e.target.value)} required />
                    </div>
                  </div>
                </div>
                <div className="btns-registro-wrapper">
                  <div className="btns-registro rest-padding-btns">
                    {/* Condición para mostrar boton*/}
                    {showBtnSearch && (
                      <div className="btn-cetesJunior">
                        <button type="submit" onClick={handleClickResumen}>{t('registro_start')}</button>
                      </div>
                    )}

                    <div className="btn-cetesJunior">
                      <button type="submit" style={{ backgroundColor: '#e02424', color: '#fff', border: '1px solid #fff' }} onClick={handleClickInicio}>{t('registro_cancel')}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="loading">
          <div className="spinner"></div>
        </div>
      ) : (
        <div>
          {/* Resto del código */}
        </div>
      )}
    </div>
  );
}



export default Registro;